import { render, staticRenderFns } from "./bofangChater.vue?vue&type=template&id=d07422f0&scoped=true"
import script from "./bofangChater.vue?vue&type=script&lang=js"
export * from "./bofangChater.vue?vue&type=script&lang=js"
import style0 from "./bofangChater.vue?vue&type=style&index=0&id=d07422f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07422f0",
  null
  
)

export default component.exports